import { Service } from '@angular/core';
import { CapacitorHttp } from '@capacitor/core';
import { from, map, Observable } from 'rxjs';
import { environment } from '@env/environment';
import { UpdateManifestDto } from '../models';

@Service()
export class HttpService {
    // CapacitorHttp, not HttpClient: updateUrl's origin is the WebView's own hostname
    // (capacitor.config.ts), so a fetch would be served the local bundle and never
    // reach the host. A native request bypasses the local server — and CORS with it.
    // CapacitorHttp only parses the body when the host labels it application/json, so a
    // latest.json served as text/plain arrives as a raw string. Parse it; a non-JSON body
    // (a 404 page) throws and lands in the caller's catchError.
    getManifest(): Observable<UpdateManifestDto> {
        return from(CapacitorHttp.get({ url: environment.updateUrl })).pipe(
            map((response) => <UpdateManifestDto>(typeof response.data === 'string' ? JSON.parse(response.data) : response.data)),
        );
    }
}
